module.exports = __webpack_public_path__ + "img/logo_blanc.af527a2c.svg";